import axios from 'axios';
import { store } from '../store';
import { logout } from '../content/auth/slice';

// Create an Axios instance with custom configuration
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Request interceptor for API calls
api.interceptors.request.use(
  (config) => {
    // Get auth state from Redux store
    const state = store.getState();
    const token = state.Auth?.user?.token || localStorage.getItem('authToken');
    
    // If token exists, add Authorization header
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for API calls
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized responses
    if (error.response && error.response.status === 401) {
      // If the token is invalid or expired, logout the user
      store.dispatch(logout());
    }
    
    return Promise.reject(error);
  }
);

export default api; 